var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear } from '@fortawesome/free-solid-svg-icons';
import { isMobile } from 'react-device-detect';
import { getParametersList } from "../../config/parametersConfig";
import { useLanguage } from '../context/LanguageContext';
import { useAppState } from '../context/AppStateContext';
import LanguageSelector from '../ui/LanguageSelector';
import { SceneStates } from "../../datas/constants";
export default function Parameters(props) {
    var _a = useLanguage(), language = _a.language, isMultilingual = _a.isMultilingual;
    var _b = useAppState(), sceneState = _b.sceneState, withSound = _b.withSound;
    var filePath = "./Ressources/textes/Intro_".concat(language, ".json");
    var _c = useState({
        home: '',
        volumeUp: '',
        volumeOff: '',
        parameters: ''
    }), tooltips = _c[0], setTooltips = _c[1];
    var _d = useState(false), menuOpen = _d[0], setMenuOpen = _d[1];
    var parametersList = getParametersList(sceneState, withSound);
    useEffect(function () {
        fetch(filePath, {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            }
        })
            .then(function (res) { return res.json(); })
            .then(function (data) { return setTooltips(data); })
            .catch(function () { return setTooltips({ home: '', volumeUp: '', volumeOff: '', parameters: '' }); });
    }, [language]);
    if ([SceneStates.LOADER, SceneStates.END_SESSION].includes(sceneState))
        return null;
    if (isMobile) {
        return (_jsxs("div", __assign({ className: "parameters-mobile" }, { children: [_jsx(FontAwesomeIcon, { icon: faGear, className: "fa-2x parameter-icon", onClick: function () { return setMenuOpen(!menuOpen); } }), menuOpen && (_jsxs("div", __assign({ className: "parameters-menu" }, { children: [parametersList.map(function (param) {
                            return param.shouldShow(props) ? (_jsx(FontAwesomeIcon, { icon: param.icon, id: param.id, onClick: function () {
                                    setMenuOpen(false);
                                    props[param.clickFunctionKey]();
                                }, className: "fa-2x parameter-icon" }, param.id)) : null;
                        }), isMultilingual && _jsx(LanguageSelector, {})] })))] })));
    }
    return (_jsxs("div", __assign({ className: "parameters-bar" }, { children: [parametersList.map(function (param) {
                if (!param.shouldShow(props))
                    return null;
                return (_jsx(Parameter, { id: param.id, icon: param.icon, tooltip: tooltips[param.tooltipKey], clickFunction: props[param.clickFunctionKey] }, param.id));
            }), isMultilingual && _jsx(LanguageSelector, {})] })));
}
function Parameter(_a) {
    var id = _a.id, icon = _a.icon, tooltip = _a.tooltip, clickFunction = _a.clickFunction;
    return (_jsx(OverlayTrigger, __assign({ placement: "bottom", overlay: _jsx(Tooltip, __assign({ id: "tooltip-".concat(id), style: { display: isMobile ? 'none' : 'block' } }, { children: tooltip }), id) }, { children: _jsx(FontAwesomeIcon, { className: "fa-2x parameter-icon", icon: icon, id: id, onClick: clickFunction }) })));
}
